// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3moxP","label":"Radio_label__1IOnL","checkMark":"Radio_checkMark__c0cWe","disabled":"Radio_disabled__2Yx6F"};